'use client'

import type { ProductMessage } from '../../../types/messageTypes'

import { ButtonGhost } from '@fukku/button/Ghost'
import { cx } from 'utils/cx'
import { useChatBotMessages } from '../../../hooks/useChatBotMessages'
import styles from './OrderProductsCard.module.scss'
import { ProductImage } from './ProductImage/ProductImage'

export function OrderProductsCard({
	products,
	orderTitle,
}: Readonly<{ products: ProductMessage[]; orderTitle: string }>) {
	const { sendHumanMessage } = useChatBotMessages()

	const onClick = () => {
		sendHumanMessage({ messageContent: orderTitle })
	}

	const productsLength = products.length
	const isOneProductGrid = productsLength === 1
	const isTwoProductsGrid = productsLength === 2

	return (
		<ButtonGhost
			className={cx(
				styles.orderProductsCard,
				isOneProductGrid && styles.oneProductGrid,
				isTwoProductsGrid && styles.twoProductsGrid
			)}
			onClick={onClick}
		>
			{products.map((product) => (
				<ProductImage
					product={product}
					key={`${orderTitle}-${product.id}`}
					hasFullSizeImage={isOneProductGrid}
					className={cx(
						isTwoProductsGrid ? styles.smallGrid : styles.regularGrid
					)}
				/>
			))}
		</ButtonGhost>
	)
}
